<div class="host-table-fixed-header">
  <div
    class="table-header"
    [style.width]="clientRect.width"
    [ngStyle]="headerStyle"
  >
    <ng-template *ngIf="showArrow" [ngTemplateOutlet]="arrow"></ng-template>
    <nz-table
      #fixedHeader
      [nzNoResult]="null"
      [nzScroll]="{ x: headerTotalWidth }"
    >
      <thead>
        <ng-template
          *ngIf="header"
          [ngTemplateOutlet]="header"
          [ngTemplateOutletContext]="{ $implicit: headerList }"
        >
        </ng-template>
      </thead>
    </nz-table>
  </div>

  <div class="table-body" #tableBody>
    <ng-template *ngIf="showArrow" [ngTemplateOutlet]="arrow"></ng-template>
    <nz-table
      #table
      [nzData]="nzData"
      [nzShowPagination]="nzShowPagination"
      [nzPageSize]="showAnotherPageSize ? nzData.length : nzPageSize"
      [nzPageIndex]="nzPageIndex"
      [nzTotal]="nzTotal"
      [nzFrontPagination]="false"
      [nzLoading]="nzLoading"
      [style.width]="headerTotalWidth"
      (nzPageIndexChange)="nzPageIndexChange.emit($event)"
    >
      <thead>
        <ng-template
          *ngIf="header"
          [ngTemplateOutlet]="header"
          [ngTemplateOutletContext]="{ $implicit: headerList }"
        >
        </ng-template>
      </thead>
      <ng-content> </ng-content>
    </nz-table>
  </div>
</div>

<ng-template #header let-headerList>
  <tr class="fixed-header">
    <th
      *ngFor="let header of headerList; index as i"
      [nzShowSort]="header?.sortable"
      [(nzSort)]="header.sort"
      (nzSortChange)="onClickSort(header?.field, $event)"
      [style.width]="header?.width"
      [style.padding-left]="
        i === 0 ? '20px' : header.paddingLeft ? header.paddingLeft : 0
      "
      [nzAlign]="nzAlign"
    >
      {{ header?.i18nName ? (header?.i18nName | translate) : header?.name }}
    </th>
  </tr>
</ng-template>

<ng-template #arrow>
  <div *ngIf="showLeftArrow" class="left-arrow" (click)="scrollLeft()">
    <img src="/assets/icon/arrow-left.png" />
  </div>
  <div
    *ngIf="showRightArrow"
    class="right-arrow"
    [style.right]="tableInModal ? 24 : 0"
    (click)="scrollRight()"
  >
    <img src="/assets/icon/arrow-right.png" />
  </div>
</ng-template>
